import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { ThunkApiType } from '@/store';
import type { MealJson } from '@/types/domain/meal/entities/mealEntity';

import { mealSlice } from '@/domain/meal/redux';
import { service } from '@/share';

export const refreshMealList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'meal/refreshMealList',
  async (_, thunkApi) => {
    const result: {
      items: MealJson[],
      nextToken: string,
    } = await service.meal.getMealList(null);
    thunkApi.dispatch(mealSlice.actions.setMealList(result));
  },
);

export const getMealList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'meal/getMealList',
  async (_, thunkApi) => {
    const { nextToken, mealList } = thunkApi.getState().meal;
    if (!nextToken) {
      if (mealList.length === 0) {
        thunkApi.dispatch(refreshMealList());
      }
      return;
    }
    const result: {
      items: MealJson[],
      nextToken: string,
    } = await service.meal.getMealList(nextToken);
    const newList = mealList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(mealSlice.actions.setMealList({
      /** データ */
      items: newList,
      /** 次のトークン */
      nextToken: result.nextToken,
    }));
  },
);

export const createMeal = createAsyncThunk<
  void,
  {
    /** データ */
    data: MealJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'meal/create',
  async (input, _thunkApi) => {
    await service.meal.createMeal(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.mealNursery.sendNurseryMeal({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);

export const deleteMeal = createAsyncThunk<
  void,
  {
    /** データ */
    data: MealJson,
    /** 施設IDリスト */
    facilityIds: string[],
  },
  ThunkApiType
>(
  'meal/delete',
  async (input, _thunkApi) => {
    await service.meal.deleteMeal(input.data);
    if (input.facilityIds.length > 0) {
      const promises = input.facilityIds.map(
        (v) => service.mealNursery.removeNurseryMeal({
          data: input.data.data,
          pub: {
            sendId: input.data.pub.sendId,
            replyId: v,
            data: { ...input.data.pub.data },
          },
        }),
      );
      await Promise.all(promises);
    }
  },
);
